var React = require('react');

function UpArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.38346 7.79302L5.21157 3.95989L5.21157 16.5281H6.99291L6.99291 3.95989L10.821 7.79302L12.0681 6.54457L6.10221 0.57302L0.136298 6.54457L1.38346 7.79302Z","fill":"#272726"}));
}

UpArrow.defaultProps = {"width":"13","height":"17","viewBox":"0 0 13 17","fill":"none"};

module.exports = UpArrow;

UpArrow.default = UpArrow;
